import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { X, Camera } from 'lucide-react';

// Phone/laptop camera QR scanner; calls onScan(text) once per new code
export const QrScanner = ({ onScan, onClose }) => {
  const ref = useRef(null);
  const last = useRef({ text: '', at: 0 });
  const [error, setError] = useState('');

  useEffect(() => {
    const scanner = new Html5Qrcode('qr-reader');
    ref.current = scanner;
    scanner.start({ facingMode: 'environment' }, { fps: 10, qrbox: { width: 240, height: 240 } }, (text) => {
      const now = Date.now();
      if (text === last.current.text && now - last.current.at < 4000) return;
      last.current = { text, at: now };
      onScan(text);
    }, () => {}).catch(() => setError('Camera unavailable — allow camera access or use the ticket ID box.'));
    return () => { if (scanner.isScanning) scanner.stop().then(() => scanner.clear()).catch(() => {}); };
  }, []);

  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" data-testid="qr-scanner-modal">
      <div className="bg-white rounded-xl w-full max-w-sm overflow-hidden">
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
          <p className="text-sm font-semibold text-[#191919] flex items-center gap-2"><Camera size={16} /> Scan ticket QR</p>
          <button onClick={onClose} data-testid="qr-scanner-close"><X size={18} className="text-[#666]" /></button>
        </div>
        <div id="qr-reader" className="w-full bg-black min-h-[260px]" />
        <p className="text-xs text-center py-3 px-4 text-[#666]" data-testid="qr-scanner-hint">{error || 'Point the camera at the QR code on the attendee ticket. Keeps scanning for the next person.'}</p>
      </div>
    </div>
  );
};
